import React, { Component } from 'react';
import { addComposedClasses, removeComposedClasses } from '../util/classList';

class AnimatedScroller extends Component {
	constructor(props) {
		super(props);

		this.state = {
			animate: 				false,
			animSlider: 			'',
			animCont: 				'',
			autoScrolling: 			false,
			componentNumToShow:		props.chunk_number_shown,
			componentMarginGap: 	props.chunk_margin_bottom,
			css:					props.CSSModules[props.condor_render_name],
			customClasses1:			props.custom_classes_1,
			customClasses2: 		props.custom_classes_2,
			customClasses3: 		props.custom_classes_3,
			modifierClasses1: 		props.modifier_classes_1,
			modifierClasses2: 		props.modifier_classes_2,
			modifierClasses3: 		props.modifier_classes_3,
			cycleCount: 			0,
			scrollByPixelsVert: 	0,
			scrollByPixelsHoriz: 	0,
			scrollerHeight: 		0,
			timerBarHeight: 		props.timer_bar_height,
			timerRunning: 			false,
			timerInterval: 			props.scroll_time_secs,
			transition: 			0
		};

		this.startAnimatedScrollerTimer = this.startAnimatedScrollerTimer.bind(this);
		this.stopAnimatedScrollerTimer = this.stopAnimatedScrollerTimer.bind(this);
		this.scrollNext = this.scrollNext.bind(this);
		this.startTimerBar = this.startTimerBar.bind(this);
		this.resetTimerBar = this.resetTimerBar.bind(this);
		this.startScrollTimer = this.startScrollTimer.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.onWheel = this.onWheel.bind(this);
		this.onTouchStart = this.onTouchStart.bind(this);

		this.animContainer = React.createRef();
		this.animSlider = React.createRef();
		this.compInnerWrap = {};
	}

	calculateSliderDimensions(componentsToShow) {
		if (this.animContainer.current === null) {
			console.error('this.animContainer has not been assigned', this.animContainer);
			return;
		}

		// React 19 fix: Force layout flush with double RAF before reading DOM dimensions
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				let timerBarHeight = this.state.timerBarHeight;
				if (this.props.processor_power !== 2) {
					timerBarHeight = 0;
				}

				let animContHeight = this.animContainer.current.clientHeight;
				let animContWidth = this.animContainer.current.clientWidth;

				let animContScrollHeight = animContHeight - timerBarHeight;
				let animContScrollWidth = animContWidth;

				let scrollByPixelsVert = Math.floor((animContScrollHeight + this.state.componentMarginGap) / componentsToShow);
				let scrollByPixelsHoriz = Math.floor((animContScrollWidth + this.state.componentMarginGap) / componentsToShow);

				let animWrapperHeight = (scrollByPixelsVert * componentsToShow) - this.state.componentMarginGap;
				let animWrapperWidth = (scrollByPixelsHoriz * componentsToShow) - this.state.componentMarginGap;

				let heightDiff = animContScrollHeight - animWrapperHeight;
				timerBarHeight += heightDiff;

				let animSlider = this.animSlider.current;

				this.setState({
					animSlider: 			animSlider,
					scrollByPixelsVert: 	scrollByPixelsVert,
					scrollByPixelsHoriz: 	scrollByPixelsHoriz,
					scrollerHeight: 		animWrapperHeight,
					scrollerWidth: 			animWrapperWidth,
					timerBarHeight: 		timerBarHeight
				});
			});
		});
	}

	componentDidMount() {
		// React 19 fix: Wait for fonts to load, then use RAF instead of arbitrary timeout
		const initializeScroller = () => {
			requestAnimationFrame(() => {
				this.calculateSliderDimensions(this.state.componentNumToShow);

				let scrollerCanAnimate =
					this.props.condor_component_list.length > this.state.componentNumToShow;

				let hasChildren = this.props.condor_component_list.length > 0;
				let canStartTimer = hasChildren && this.props.scroll_time_secs > 0;

				this.setState({
					animate: scrollerCanAnimate
				});

				setTimeout(() => {
					if (canStartTimer) {
						this.startAnimatedScrollerTimer();
					}
				}, 10000);
			});
		};

		// Wait for fonts to load before initializing
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => {
				initializeScroller();
			});
		} else {
			// Fallback for browsers without font loading API
			initializeScroller();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.chunk_number_shown !== this.props.chunk_number_shown ||
			prevProps.condor_component_list !== this.props.condor_component_list
		) {
			this.calculateSliderDimensions(this.props.chunk_number_shown);

			let scrollerCanAnimate =
				this.props.condor_component_list.length > this.props.chunk_number_shown;

			let hasChildren = this.props.condor_component_list.length > 0;
			let canStartTimer = hasChildren && this.props.scroll_time_secs > 0;

			this.setState({
				animate: scrollerCanAnimate
			});

			if (prevProps.scroll_time_secs !== this.props.scroll_time_secs) {
				this.setState({ timerInterval: this.props.scroll_time_secs });
			}

			if (canStartTimer) {
				setTimeout(() => {
					this.startAnimatedScrollerTimer();
				}, 10);
			} else {
				this.stopAnimatedScrollerTimer();
			}
		}
	}

	returnClasses = (array) => {
		let newClassList = '';
		if (Array.isArray(array) && array.length > 0) {
			array.forEach((item) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(item)) {
					newClassList += ` ${item}`;
				}
			});
		}
		return newClassList;
	}

	returnModifierClasses = (array) => {
		let newClassList = '';
		if (array && Array.isArray(array)) {
			array.forEach((item) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(item)) {
					newClassList += ` ${item}`;
				}
			});
		}
		return newClassList;
	}

	// Begin countdown to auto animate upward
	startAnimatedScrollerTimer = () => {
		this.setState({ autoScrolling: true });

		clearInterval(this.timer);

		if (this.state.cycleCount > 0) {
			this.setState({ cycleCount: 0 });
		}

		let tick = this.state.timerInterval * 1000;
		this.startTimerBar();

		this.timer = setInterval(() => {
			this.resetTimerBar();
			this.scrollNext();
			this.startTimerBar();
		}, tick);
	}

	// Clear scroll timer
	stopAnimatedScrollerTimer = () => {
		clearInterval(this.timer);
		this.setState({
			cycleCount: 0,
			timerRunning: false
		});
	}

	// Mouse wheel
	onWheel = () => {
		if (this.state.animate === true) {
			clearTimeout(this.scrollTimer);
			clearInterval(this.timer);
			this.setState({ autoScrolling: false });
		}
	}

	// Screen touch
	onTouchStart = () => {
		if (this.state.animate === true) {
			clearTimeout(this.scrollTimer);
			clearInterval(this.timer);
			this.setState({ autoScrolling: false });
		}
	}

	// On scroll
	onScroll = () => {
		if (this.state.autoScrolling === false && this.state.animate === true) {
			this.stopAnimatedScrollerTimer();
			this.resetTimerBar();
			this.startScrollTimer();

			let scrollPosition = this.state.animSlider.scrollTop;
			let scrollPixelValue = this.state.scrollByPixelsVert;

			if (this.props.scroll_type === 1) {
				scrollPosition = this.state.animSlider.scrollLeft;
				scrollPixelValue = this.state.scrollByPixelsHoriz;
			}

			if (scrollPosition >= scrollPixelValue) {
				this.swapContent();
			}
		}
	}

	// After manual scroll, snap & resume
	startScrollTimer = () => {
		clearTimeout(this.scrollTimer);
		this.scrollTimer = setTimeout(() => {
			let animScroller = this.state.animSlider;
			let position = animScroller.scrollTop;
			let scrollAmount = this.state.scrollByPixelsVert;

			if (this.props.scroll_type === 1) {
				position = animScroller.scrollLeft;
				scrollAmount = this.state.scrollByPixelsHoriz;
			}

			if (position % scrollAmount !== 0) {
				if (position < scrollAmount / 2) {
					if (this.props.scroll_type === 1) {
						animScroller.scrollLeft = 0;
					} else {
						animScroller.scrollTop = 0;
					}
				} else if (position < scrollAmount) {
					if (this.props.scroll_type === 1) {
						animScroller.scrollLeft = scrollAmount;
					} else {
						animScroller.scrollTop = scrollAmount;
					}
					setTimeout(() => {
						this.swapContent();
					}, 400);
				}
			}

			this.startAnimatedScrollerTimer();
		}, 100);
	}

	scrollNext() {
		let css = this.state.css;
		let swapContent = this.swapContent;

		let scrollByPixels = this.state.scrollByPixelsVert;
		let scrollX = 0;
		let scrollY = scrollByPixels;
		if (this.props.scroll_type === 1) {
			scrollByPixels = this.state.scrollByPixelsHoriz;
			scrollX = scrollByPixels;
			scrollY = 0;
		}

		let cycleCount = this.state.cycleCount + 1;

		if (this.state.animate && this.animSlider.current) {
			if (this.props.processor_power === 1) {
				let compInnerWrap = Object.values(this.compInnerWrap).map((node) => {
					return node?.current;
				});
				compInnerWrap.forEach((item) => {
					addComposedClasses(item, css.compFadeOut);
				});

				setTimeout(() => {
					// React 19 fix: Use optional chaining for extra safety
					// eslint-disable-next-line no-unused-expressions
					this.animSlider.current?.scrollBy(scrollX, scrollY);
				}, 175);

				setTimeout(() => {
					swapContent();
				}, 450);

				setTimeout(() => {
					compInnerWrap.forEach((item) => {
						removeComposedClasses(item, css.compFadeOut);
					});
				}, 500);

			} else {
				// React 19 fix: Use optional chaining for extra safety
				// Standard scrolling
				// eslint-disable-next-line no-unused-expressions
				this.animSlider.current?.scrollBy(scrollX, scrollY);
				setTimeout(() => {
					swapContent();
				}, 700);
			}
		}

		this.setState({
			cycleCount,
			timerRunning: true
		});
	}

	// Move top node to bottom
	swapContent = () => {
		const animSlider = this.animSlider.current;
		if (!animSlider) return;

		const animSlider1stChild = animSlider.firstChild;
		const animSliderLastChild = animSlider.lastChild;

		// React 19 fix: Add null checks before DOM manipulation
		if (!animSlider1stChild || !animSliderLastChild) {
			console.warn('AnimatedScroller: Cannot swap content, children not ready');
			return;
		}

		animSliderLastChild.after(animSlider1stChild);

		animSlider.style.scrollBehavior = 'auto';
		animSlider.scrollTo(0, 0);
		animSlider.style.scrollBehavior = 'smooth';
	}

	// Start timer bar
	startTimerBar = () => {
		this.setState({
			transition: 1
		});
	}

	// Reset timer bar
	resetTimerBar = () => {
		this.setState({
			transition: 0
		});
	}

	// Timer bar style
	timebarStyles = (isOn) => {
		let style = {
			transition: `${this.state.timerInterval}s all linear`,
			width: '100%'
		};
		if (isOn === 1) {
			return style;
		}
		return;
	}

	// Conditionally create time bar
	createTimeBar = () => {
		let css = this.state.css;
		let style = {
			marginTop: this.state.timerBarHeight - 3
		};
		if (this.state.animate === true && this.props.processor_power === 2) {
			return (
				<div className={css.timerBar} style={style}>
					<div
						className={css.timerBarActive}
						style={this.timebarStyles(this.state.transition)}
					></div>
				</div>
			);
		}
	}

	// If animation is disabled, remove scroll
	disableAnimation = () => {
		if (!this.state.animate) {
			let style = {
				overflowX: 'hidden',
				overflowY: 'hidden'
			};
			return style;
		}
	}

	render() {
		let css = this.state.css;
		let orientation = 'Vert';
		let animWrapperStyles = {
			height: `${this.state.scrollerHeight}px`
		};

		if (this.props.scroll_type === 1) {
			orientation = 'Horiz';
			animWrapperStyles = {
				width: `${this.state.scrollerWidth}px`
			};
		}

		let animationStyle = css.animationScroll;
		if (this.props.processor_power === 0 || this.props.processor_power === 1) {
			animationStyle = css.animationLow;
		}

		let addComponents = [];
		let animatedScroller = (this.props.condor_component_list && this.props.condor_component_list.length > 1);

		// React 19 fix: Replace React.cloneElement with direct component rendering
		this.props.condor_component_list.forEach((element, i) => {
			const ElementType = element.type;
			let newElm = (
				<ElementType
					{...element.props}
					key={element.key || `scroller-item-${i}`}
					animatedScroller={animatedScroller}
					animatedScrollerTimer={this.props.scroll_time_secs}
					cycleCount={this.state.cycleCount}
				/>
			);

			addComponents.push(
				<ScrollerChild
					newElm={newElm}
					key={`childKey_${i}`}
					childNum={i}
					childrenLength={this.props.condor_component_list.length - 1}
					css={this.state.css}
					scrollByPixelsVert={this.state.scrollByPixelsVert}
					scrollByPixelsHoriz={this.state.scrollByPixelsHoriz}
					componentMarginGap={this.state.componentMarginGap}
					animScroller_name={this.props.component_name}
					render_name={element.props.condor_render_name}
					scroll_type={this.props.scroll_type}
					cycleCount={this.state.cycleCount}
					animatedScroller={this}
				/>
			);
		});

		return (
			<div
				ref={this.animContainer}
				className={`animScroll_container ${css.animCont} ${css[`animCont${orientation}`]} ${this.returnModifierClasses(this.state.modifierClasses1)} ${this.returnClasses(this.state.customClasses1)}`}
				data-test-id="animScrollContainer"
			>
				<div
					id={`animWrapper_${this.props.component_name}`}
					className={`animScroll_wrapper ${css.animWrapper} ${css[`animWrapper${orientation}`]} ${this.returnModifierClasses(this.state.modifierClasses2)} ${this.returnClasses(this.state.customClasses2)}`}
					style={animWrapperStyles}
				>
					<div
						ref={this.animSlider}
						className={`animScroll_slider ${css.animSlider} ${css[`animSlider${orientation}`]} ${animationStyle} ${this.returnModifierClasses(this.state.modifierClasses3)} ${this.returnClasses(this.state.customClasses3)}`}
						style={this.disableAnimation()}
						onScroll={this.onScroll}
						onTouchStart={this.onTouchStart}
						onWheel={this.onWheel}
					>
						{addComponents}
					</div>
				</div>
				{this.createTimeBar()}
			</div>
		);
	}
}

class ScrollerChild extends React.Component {
	constructor(props) {
		super(props);
		props.animatedScroller.compInnerWrap[props.childNum] = React.createRef();
	}

	render() {
		let css = this.props.css;
		let style = {
			height: this.props.scrollByPixelsVert
		};
		let styleInner = {
			marginBottom: this.props.componentMarginGap
		};
		let orientation = 'Vert';

		if (this.props.scroll_type === 1) {
			style = {
				width: this.props.scrollByPixelsHoriz
			};
			styleInner = {
				marginRight: this.props.componentMarginGap
			};
			orientation = 'Horiz';
		}

		let inner = (
			<div
				className={`compWrapper_${this.props.animScroller_name} animScroll_compWrapper ${css.compWrapper}`}
				style={styleInner}
			>
				<div
					ref={this.props.animatedScroller.compInnerWrap[this.props.childNum]}
					className={`${css.compInnerWrap} animScroll_innerWrap compInnerWrap_${this.props.animScroller_name}`}
				>
					{this.props.newElm}
				</div>
			</div>
		);

		return (
			<div
				data-child={`${this.props.childNum}-${this.props.render_name}`}
				className={`compContainer_${this.props.animScroller_name} ${css.compContainer} animScroll_comp${orientation} ${css[`comp${orientation}`]}`}
				style={style}
			>
				{inner}
			</div>
		);
	}
}

export default AnimatedScroller;
